import { render, staticRenderFns } from "./PePriceRail.vue?vue&type=template&id=c6308c2c&"
import script from "./PePriceRail.vue?vue&type=script&lang=js&"
export * from "./PePriceRail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports